
    import {defineComponent, reactive, ComputedRef, computed, watch} from 'vue';
    import {useStore} from "@/store";

    interface State {
        isShowModel: boolean;
        checkItemSum: number;
    }

    export default defineComponent({
        name: "totalCheck",
        setup() {
            let state: State = reactive({
                isShowModel: false,
                checkItemSum: 0,
            })
            let store = useStore()
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {accident, fire, soakWater} = data;
                const itemCountAccident = accident.itemCount;
                const itemCountFire = fire.itemCount;
                const itemCountWater = soakWater.itemCount;
                state.checkItemSum = itemCountAccident + itemCountFire + itemCountWater;
            })
            return {
                state
            }
        },
        methods: {
            showModel() {
                this.state.isShowModel = true
                document.body.style.overflow = "hidden" 
            },
            hiddenModel(){
                this.state.isShowModel = false
                document.body.style.overflow = "" 
            }
        }
    })
